//Author : Rohan Patel
export const VIEW_RESTAURANT_DATA = "VIEW_RESTAURANT_DATA";
export const ADD_RESTAURANT = "ADD_RESTAURANT";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const ADD_TABLE = "ADD_TABLE";
export const DELETE_TABLE = "DELETE_TABLE";
export const UPDATE_DINEIN = "UPDATE_DINEIN";
export const UPDATE_TAKEOUT = "UPDATE_TAKEOUT";
